<template>
	<section id="reviews" class="section reviews" v-if="reviews && reviews.length">
	  <!-- <div class="reviews-container">

      <h3 class="reviews__title">What the team thinks about life at {{ org_name }}</h3>
      <p class="reviews__sub-title">We asked our team to review us, here's what they had to say &hellip;</p>

      <ul class="reviews__list">
        <li class="reviews__list-item" v-for="(review,r) in reviews" :key="`${r}_${review.name}`">
          <div class="reviews__list-item-inner">
            <p class="reviews__list-item-review" v-if="review.review.length < 400 || review.expanded">{{ review.review }} <template v-if="review.expanded"><br/><a href="#" class="underline" @click.prevent="review.expanded = false">Read less</a></template></p>
						<p class="reviews__list-item-review" v-else>{{ review.review.substring(0, 400) }}&hellip; <br/><a href="#" class="underline" @click.prevent="review.expanded = true">Read more</a></p>
            <p class="reviews__list-item-name">{{ review.name }}</p>
          </div>
        </li>
      </ul>

      <div class="btn-center">
        <button class="btn btn-blue btn-medium btn-rounded" v-if="canShowMore" @click="doLoadMore">Load more</button>
      </div>

	  </div> -->

		<div class="reviews-container-v2">

      <h3 class="reviews__title">What the team says</h3>

			<div class="review__summary">
				<div class="review__summary-item">
					<div class="review__summary-icon">
						<img src="/images/icons/star.svg"  class="ml-1 mr-5 icon w-7 h-7" alt="Star"/>
					</div>
					<div class="review__summary-title">
							{{ score_latest }} <span>/ 10*</span>
					</div>
				</div>
				<div class="review__summary-item">
					<div class="review__summary-icon">
						<img src="/images/icons/icon-conversation.svg"  class="mr-4 icon w-9 h-9" alt="Conversations"/>
					</div>
					<div class="review__summary-title">
							{{reviews_total}} <span>verified employee reviews</span>
					</div>
				</div>
				<div class="review__summary-best-for">
					<p>Best for...<br/><span>(as reviewed by current employees)</span></p>
					<ul>
						<li v-for="(item, i) in bestFor" :key="`best-for-${i}`">
							{{ item.tag }}
							<div class="roundal">{{ item.count }}</div>
						</li>
					</ul>
				</div>
				<div class="review__summary-disclaimer">
					<p>* Employees annoymously reviewed this organisation as part of our Escape 100: Top Organisations to escape to campaign.</p>
				</div>
			</div>

			<div class="reviews__container">
				<ul class="reviews__list">
					<li class="reviews__list-item" v-for="(review,r) in reviews" :key="`${r}_${review.name}`">
						<div class="reviews__list-item-inner">
							<div class="reviews__list-item-header">
								<div class="reviews__list-item-avatar">
									<template v-if="review.name == ''">
										<img src="/images/icons/icon-smiley.svg" class="w-5 icon" alt="Employee"/>
									</template>
									<template v-else>
										{{ initialsOf(review.name) }}
									</template>
								</div>
								<div class="reviews__list-item-info">
									<p class="reviews__list-item-name">{{ (review.name == '') ? 'Employee' : review.name }}</p>
									<p class="reviews__list-item-date">{{ review.date ?? '' }}</p>
								</div>
							</div>
							<div class="reviews__list-item-review" v-html="nl2br(review.review)"></div>
						</div>
					</li>
				</ul>

				<div class="btn-center">
					<button class="btn btn-blue-dark btn-medium btn-normal" v-if="canShowMore" @click="doLoadMore">Load more&hellip;</button>
				</div>
			</div>

	  </div>
	</section>
</template>

<script>
	export default {
    name: 'OrganisationReviews',

		props: {
			org_main_id: {
				type: String
			},
			org_name: {
				type: String
			},
			score_latest: {
				type: String
			},
			reviews_total: {
				type: String
			}
		},

		data() {
			return {
				bestFor: false,
				reviews: false,
        reviewsToShow: 3,
        canShowMore: true
			}
		},

		mounted() {
			this.loadData();
		},

		methods: {
			loadData() {
				let payload = {'org_main_id':this.org_main_id}
	  		return this.$api.loadOrganisationReviews(payload).then(
	        (response) => {
						let bestfor = response.data['best-for'];

						this.bestFor = bestfor.filter((bf) => {
							return bf.count > 0;
						}).sort(this.sortGoodFor);

						this.allRreviews = response.data.reviews;
						this.allRreviews.forEach((review) => {
							review.expanded = false;
						})
            this.reviews = this.allRreviews.splice(0, this.reviewsToShow);
						this.$nextTick(this.checkAnchorScroll);
	        }
	      ).catch((response) => {
	        console.log("Could not load reviews.", response);
	      });
			},
      doLoadMore() {
        if (this.canShowMore) {
          this.reviews = this.reviews.concat(this.allRreviews.splice(0, this.reviewsToShow));
          this.canShowMore = this.allRreviews.length > 0;
        }
	    },
			initialsOf(name) {
				let output = '';
				let parts = name.split(" ");
				parts.forEach((part) => {
					output += part.substring(0,1);
				})
				return output;
			},
			sortGoodFor(a, b) {
				if (a.count < b.count) {
					return 1;
				}
				if (a.count > b.count) {
					return -1;
				}
				// a must be equal to b
				return 0;
			},
			nl2br (str) {
				if (typeof str === 'undefined' || str === null) {
						return '';
				}
				var breakTag = '<br />';
				return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
			},
			checkAnchorScroll() {
				if(window.location.hash && window.location.hash == '#reviews') {
					var element_to_scroll_to = document.getElementById('reviews');
					if (element_to_scroll_to) {
						element_to_scroll_to.scrollIntoView();
					}
				}
			}
		}
	}
</script>
